import onChange from 'on-change';
import classNames from '../globals/classNames';
import selectors from '../globals/selectors';

class View {
	constructor(element) {
		this.toggle = element.querySelector(selectors.accordion.toggle);
		this.content = element.querySelector(selectors.accordion.content);
		this.icon = element.querySelector(selectors.accordion.icon);
	}

	init(state) {
		return onChange(state, () => {
			this.render(state);
		});
	}

	render(state) {
		this.toggle.classList.toggle(
			classNames.accordion.toggleActive,
			state.isOpened
		);
		this.content.classList.toggle(
			classNames.accordion.contentActive,
			state.isOpened
		);

		const hasIcon = this.icon !== null;
		if (hasIcon) {
			this.icon.classList.toggle(classNames.accordion.iconActive);
		}
	}

	initListeners({ handleToggleClick }) {
		this.toggle.addEventListener('click', handleToggleClick);
	}
}

export default (element, initialState = {}) => {
	const state = {
		isOpened: false,
		...initialState,
	};

	const view = new View(element);
	const watchedState = view.init(state);

	const handleToggleClick = (ev) => {
		ev.preventDefault();

		watchedState.isOpened = !watchedState.isOpened;
	};

	view.initListeners({ handleToggleClick });
};
